<app-wrapper>
    <app-searchresults (resultSelected)="resultSelected($event)"></app-searchresults> 
</app-wrapper>
